import React from "react";

const MiniSubscriptioncardSkeleton = () => {
  return (
    <div>
      <div className="lg:w-[222px] w-[130px] h-[285px] bg-[#1a1919] animate-pulse mt-2"></div>
    </div>
  );
};

export default MiniSubscriptioncardSkeleton;
